import React from "react";
import { IconsType } from "../../../libs/Utils/types";
import clsx from "clsx";
import s from "./Transactions.module.scss"
function Transactions({ height, width, fill }: IconsType) {
  return (
    <div className={clsx(!width && s.wrapper)}>
      <svg
        viewBox="0 0 14 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          width: width || "100%",
          height: height || "100%",
        }}
        preserveAspectRatio="xMidYMid meet"

      >
        <path
          d="M13.383 1.01971C13.009 0.862705 12.58 0.950705 12.293 1.23671L11 2.52971L9.707 1.23671C9.316 0.845705 8.684 0.845705 8.293 1.23671L7 2.52971L5.707 1.23671C5.316 0.845705 4.684 0.845705 4.293 1.23671L3 2.52971L1.707 1.23671C1.421 0.950705 0.992 0.863705 0.617 1.01971C0.243 1.17371 0 1.53971 0 1.94371V19.9437C0 20.3477 0.243 20.7137 0.617 20.8677C0.991 21.0237 1.421 20.9377 1.707 20.6507L3 19.3577L4.293 20.6507C4.684 21.0417 5.316 21.0417 5.707 20.6507L7 19.3577L8.293 20.6507C8.684 21.0417 9.316 21.0417 9.707 20.6507L11 19.3577L12.293 20.6507C12.484 20.8417 12.74 20.9437 13 20.9437C13.129 20.9437 13.259 20.9197 13.383 20.8677C13.757 20.7137 14 20.3477 14 19.9437V1.94371C14 1.53971 13.757 1.17371 13.383 1.01971ZM10 15.9437H4C3.447 15.9437 3 15.4967 3 14.9437C3 14.3907 3.447 13.9437 4 13.9437H10C10.553 13.9437 11 14.3907 11 14.9437C11 15.4967 10.553 15.9437 10 15.9437ZM10 11.9437H4C3.447 11.9437 3 11.4967 3 10.9437C3 10.3907 3.447 9.94371 4 9.94371H10C10.553 9.94371 11 10.3907 11 10.9437C11 11.4967 10.553 11.9437 10 11.9437ZM10 7.94371H4C3.447 7.94371 3 7.49671 3 6.94371C3 6.39071 3.447 5.94371 4 5.94371H10C10.553 5.94371 11 6.39071 11 6.94371C11 7.49671 10.553 7.94371 10 7.94371Z"
          fill={fill||"#6A6767"}
        />
      </svg>
    </div>
  );
}

export default Transactions;
